import React, { useCallback, useState } from 'react';
import { createContext, useContext } from 'react';

type UIClassName = 'ui-app-background' | 'ui-point-bg';
type AppUIContextProps = {
  uiClassName: UIClassName | null;
  setUIClassName: (uiClassName: UIClassName) => { cleanup: () => void }; // clean up functionも返している
};

const AppUIContext = createContext<AppUIContextProps>({
  uiClassName: null,
  setUIClassName: _ => ({
    cleanup: () => {
      return;
    },
  }),
});

export const useAppUIContext = (): AppUIContextProps => {
  const context = useContext(AppUIContext);

  return context;
};

export const AppUIProvider = (props: { children: React.ReactNode }) => {
  const [uiClassName, setUIClassName_] = useState<UIClassName | null>(null);
  const setUIClassName = useCallback((uiClassName: UIClassName): {
    cleanup: () => void;
  } => {
    setUIClassName_(uiClassName);
    return { cleanup: () => setUIClassName_(null) };
  }, []);
  return (
    <>
      <AppUIContext.Provider
        value={{
          uiClassName,
          setUIClassName,
        }}>
        {props.children}
      </AppUIContext.Provider>
    </>
  );
};
